module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/training-certificate/training-certificate-form/training-certificate-form.component.css
// module id = ./src/app/pages/functions/training-certificate/training-certificate-form/training-certificate-form.component.css
// module chunks = main